import { render, staticRenderFns } from "./push.vue?vue&type=template&id=5b2c8e9d"
import script from "./push.vue?vue&type=script&lang=js"
export * from "./push.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports